import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import CompanyInfo from "components/menu/master-files/company-info/edit-form";

const CompanyInfoRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={CompanyInfo}
            />
        </Switch>
    </div>
);

export default connect()(CompanyInfoRouter);
